import adminApi from "../../../../api/adminApi";
import type { ApiGatewaySyncLogs } from "../../../../api/types/integrationsTypes";
import LogsWrapper from "../../../common/syncLogs/LogsWrapper";
import LogsTable from "./LogsTable";

const Logs = () => {
  return (
    <LogsWrapper<ApiGatewaySyncLogs>
      fetchLogsFromApi={(params) => adminApi.getApiGatewayLogs(params)}
      renderTable={(logItems) => <LogsTable logItems={logItems} />}
    />
  );
};

export default Logs;
